import React, { useRef, useState } from 'react';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import InputAdornment from '@material-ui/core/InputAdornment';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Paper from '@material-ui/core/Paper'
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import TextField from '@material-ui/core/TextField';

import { emailChecker } from '../../../app/data/validate';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';
import Typography from '@material-ui/core/Typography'

const OrganizationMemberInput = ({ index, item: { name, email, phoneNumber, role, pseudo = false }, onChange, onDelete, classes }) => {
    const [activeRow, setActiveRow] = useState(-1);
    const nameRef = useRef();
    const emailRef = useRef();
    const phoneRef = useRef();
    const roleRef = useRef();

    const handleEmailChange = (index, fragment) => {
        if (emailChecker.test(fragment.email.trim())) {
            onChange(index, fragment);
        }
    }

    return (
        <Grid item container spacing={2} xs={12} lg={4}>
            <Paper style={{ padding: '1rem', marginBottom: '1rem', marginRight: '1rem' }}>
                <div onMouseEnter={() => setActiveRow(index)} onMouseLeave={() => setActiveRow(-1)} >

                    <TextField
                        label="Referrer Name"
                        defaultValue={name}
                        inputRef={nameRef}
                        onChange={() => onChange(index, { name: nameRef.current.value })}
                        variant="outlined"
                        fullWidth
                        style={{ marginTop: '1rem' }}
                    />
                    <TextField
                        label="Email Address"
                        type="text"
                        defaultValue={email}
                        inputRef={emailRef}
                        onChange={() => handleEmailChange(index, { email: emailRef.current.value.trim() })}
                        variant="outlined"
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><MailOutlineIcon /></InputAdornment>,
                        }}
                        fullWidth
                        style={{ marginTop: '1rem' }}
                    />
                    <TextField
                        label="Contact Number"
                        type="text"
                        defaultValue={phoneNumber}
                        inputRef={phoneRef}
                        onChange={() => onChange(index, { phoneNumber: phoneRef.current.value })}
                        variant="outlined"
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><PhoneAndroidIcon /></InputAdornment>,
                        }}
                        fullWidth
                        style={{ marginTop: '1rem' }}
                    />
                    <TextField
                        label="Role"
                        type="text"
                        defaultValue={role || ''}
                        inputRef={roleRef}
                        onChange={() => onChange(index, { role: roleRef.current.value })}
                        variant="outlined"
                        fullWidth
                        style={{ marginTop: '1rem' }}
                    />
                    <Typography
                        style={{ marginTop: '1rem' }}
                        variant="subtitle2"
                        color="initial">If you're creating this referrer because they can't or won't sign up to TICIT themselves then set the switch below to on to create an account for the referrer</Typography>
                    <MuiSwitch
                        onChange={value => onChange(index, { pseudo: value })}
                        label="Create a user account for this referrer"
                        value={pseudo}
                    />
                    {
                        activeRow === index ?
                            <Button
                                variant="contained"
                                onClick={() => onDelete(index)}
                                aria-label="delete"
                                color="secondary"
                                fullWidth
                                style={{ marginTop: '1rem' }}>DELETE this referrer
                            </Button>
                            : <></>
                    }
                </div>
            </Paper>
        </Grid>
    )
    
}

export default OrganizationMemberInput;